// src/data/permissions.ts

export interface Permission {
  label: string; // Ex: "Cadastrar"
  value: string; // Ex: "ROLE_USUARIO_REGISTRAR"
}

export interface PermissionGroup {
  key: string; // Ex: "users" (para usar com i18next)
  permissions: Permission[];
}

export const permissionGroups: PermissionGroup[] = [
  {
    key: "users",
    permissions: [
      { label: "Listar", value: "ROLE_USUARIO_LISTAR" },
      { label: "Cadastrar", value: "ROLE_USUARIO_REGISTRAR" },
      { label: "Editar", value: "ROLE_USUARIO_EDITAR" },
      { label: "Apagar", value: "ROLE_USUARIO_DELETAR" },
    ],
  },
  {
    key: "profile",
    permissions: [
      { label: "Listar", value: "ROLE_PERFIL_LISTAR" },
      { label: "Cadastrar", value: "ROLE_PERFIL_REGISTRAR" },
      { label: "Editar", value: "ROLE_PERFIL_EDITAR" },
      { label: "Apagar", value: "ROLE_PERFIL_DELETAR" },
    ],
  },
  {
    key: "clients",
    permissions: [
      { label: "Listar", value: "ROLE_CLIENTE_LISTAR" },
      { label: "Cadastrar", value: "ROLE_CLIENTE_REGISTRAR" },
      { label: "Editar", value: "ROLE_CLIENTE_EDITAR" },
      { label: "Apagar", value: "ROLE_CLIENTE_DELETAR" },
    ],
  },
  {
    key: "products",
    permissions: [
      { label: "Listar", value: "ROLE_PRODUTO_LISTAR" },
      { label: "Cadastrar", value: "ROLE_PRODUTO_REGISTRAR" },
      { label: "Editar", value: "ROLE_PRODUTO_EDITAR" },
      { label: "Apagar", value: "ROLE_PRODUTO_DELETAR" },
    ],
  },
  {
    key: "resources",
    permissions: [
      { label: "Listar", value: "ROLE_RECURSO_LISTAR" },
      { label: "Cadastrar", value: "ROLE_RECURSO_REGISTRAR" },
      { label: "Editar", value: "ROLE_RECURSO_EDITAR" },
      { label: "Apagar", value: "ROLE_RECURSO_DELETAR" },
    ],
  },
  {
    key: "licenses",
    permissions: [
      { label: "Listar", value: "ROLE_LICENCA_LISTAR" },
      { label: "Cadastrar", value: "ROLE_LICENCA_REGISTRAR" },
      { label: "Editar", value: "ROLE_LICENCA_EDITAR" },
      { label: "Apagar", value: "ROLE_LICENCA_DELETAR" },
      { label: "Editar Frequência", value: "ROLE_LICENCA_EDITAR_FREQUENCIA"},
    ],
  },
  {
    key: "metadata",
    permissions: [
      { label: "Visualizar", value: "ROLE_VISUALIZAR_METADADOS" }
    ],
  },
];

type UserPermissions = string[] | undefined | null;

export const checkHasPermission = (
  userPermissions: UserPermissions,
  requiredPermission: string
): boolean => {
  if (!userPermissions || userPermissions.length === 0 || !requiredPermission) {
    return false;
  }
  return userPermissions.includes(requiredPermission);
};

export const checkHasAtLeastOnePermission = (
  userPermissions: UserPermissions,
  requiredPermissions: string[]
): boolean => {
  if (!userPermissions || userPermissions.length === 0 || !requiredPermissions || requiredPermissions.length === 0) {
    return false;
  }

  return requiredPermissions.some(permission => userPermissions.includes(permission));
};